import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content max-h-full" }

import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseCustomModal',
  setup(__props) {

const isShown = ref<boolean>(false)

onMounted(() => {
  isShown.value = true
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "dialog-anim" }, {
    default: _withCtx(() => [
      (isShown.value)
        ? (_openBlock(), _createElementBlock("section", {
            key: 0,
            class: "dialog-curtain full custom-modal",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})